import axios from "axios";

export function fetchVoucherSetting({ uuid }) {
  return new Promise((resolve, reject) => {
    axios.get(`/consumer/admin/api/v1/survey/${uuid}/voucher-setting`)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}